module.exports = __webpack_public_path__ + "media/images/home/ic_resend_email-187bf4b5469aa29669260e51c53e5643.svg";